import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";

import { EnabledCompaniesStoreService } from "./enabled-companies-store.service";
import { CompaniesEnabled } from "./enabled-companies.types";

@Injectable({
  providedIn: "root",
})
export class EinvoicingEnabledService {
  enabledCompaniesSubject = new ReplaySubject<CompaniesEnabled>();
  enabledCompanies$ = this.enabledCompaniesSubject.asObservable();
  enabledCompanies: CompaniesEnabled;

  constructor(private enabledCompaniesStore: EnabledCompaniesStoreService) {}

  fetchConfig() {
    const cachedEntry = this.enabledCompaniesStore.getStoredCompaniesEnabled(
      "einvoicing",
    );
    if (cachedEntry) {
      this.enabledCompanies = cachedEntry;
      this.enabledCompaniesSubject.next(cachedEntry);
    }

    const sub = this.enabledCompaniesStore.fetchCompaniesEnabled(
      "einvoicing",
    );
    if (!sub) {
      console.warn("No way2vat data found in local storage");
      return;
    }

    sub.subscribe({
      next: (enabledCompaniesData) => {
        this.enabledCompanies = enabledCompaniesData;
        this.enabledCompaniesSubject.next(enabledCompaniesData);
      },
      error: (error) => {
        console.error(
          "Error fetching company enabled products (E-Invoicing):",
          error,
        );
      },
    });
    return sub;
  }
}
